<script lang="ts">
  interface Props {
    hidden?: boolean
  }

  let { hidden }: Props = $props();
</script>

<div class={{ 'ft5-upselling-ai oc-copy-75': true, 'ft5-upselling-opacity-0': hidden }}>
    <oc-icon-v1
        size="100"
        type="chatbot"
    ></oc-icon-v1>
    <div class="ft5-upselling-ai-text">Alternative durch KI ermittelt</div>
</div>

<style lang="scss">

  @use "@otto-ec/design-tokens/tokens";

  .ft5-upselling-ai {
    display: flex;
    align-items: center;
    margin-top: 8px;
    color: tokens.$oc-semantic-color-text-secondary;
    opacity: 1;
    transition: opacity 1s;;
  }

  .ft5-upselling-opacity-0 {
    opacity: 0;
  }

  .ft5-upselling-ai-text {
    margin-left: 8px;
  }

</style>
